export default __webpack_public_path__ + "static/media/LearnMoreHappyFriends.1be0c4a9.png";